import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import withStyles from "@material-ui/core/styles/withStyles";
import { useAppState } from "../../shared/ContextProvider";

const StyledSwitch = withStyles({
  switchBase: {
    color: "#C2C2C2",
    "&$checked": {
      color: "#2196F3",
    },
    "&$checked + $track": {
      backgroundColor: "#BBDEFB",
    },
  },
  checked: {},
  track: {},
})(Switch);

const StyledFormControlLabel = withStyles({
  label: {
    fontSize: 14,
  },
})(FormControlLabel);

export default function SwitchComponent() {
  const { state, dispatch } = useAppState();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({ type: "CONSULTING" });
  };

  return (
    <StyledFormControlLabel
      control={
        <StyledSwitch checked={state.consulting} onChange={handleChange} />
      }
      label="상담 중인 요청만 보기"
    />
  );
}
